import React, { useContext } from "react";
import PropTypes from "prop-types";
import MobileContext from "context/MobileContext";
import LeftArrow from "./LeftArrow";
import RightArrow from "./RightArrow";
import PaddingElement from "./PaddingElement";
import Dots from "./Dots";
import styles from "./styles.module.scss";

const Carousel = (
  { children, increment, decrement, disableGradient, index, ...props },
  ref
) => {
  const isMobileView = useContext(MobileContext); // use this over isTouch() or css checking. It can determine mobile user during ssr nad all mobile have touch.

  const handleScroll = (e) => {
    e.persist();
    props.handleScroll(e);
  };

  const length = React.Children.count(children);

  return (
    <div className={styles.carousel}>
      {!disableGradient && <div className={styles.gradient} />}
      <div ref={ref} onScroll={handleScroll} className={styles.carouselInner}>
        {children}
        <PaddingElement />
      </div>
      {!isMobileView && (
        <div className={styles.buttonContainer}>
          <button
            type="button"
            onClick={decrement}
            className={styles.decrementButton}
            disabled={index < 1}
            title="previous image"
          >
            <LeftArrow />
          </button>
          <button
            type="button"
            onClick={increment}
            className={styles.incrementButton}
            disabled={index >= length - 1}
            title="next image"
          >
            <RightArrow />
          </button>
        </div>
      )}
      {isMobileView && <Dots value={index} count={length} />}
    </div>
  );
};

export default React.forwardRef(Carousel);

Carousel.propTypes = {
  children: PropTypes.node,
  handleScroll: PropTypes.func.isRequired,
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  disableGradient: PropTypes.bool,
};

Carousel.defaultProps = {
  children: null,
  disableGradient: false,
};
